module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/homes_iwaki-dc1624273e716dc44b160bb04d69f5bf.jpg";